import { Check } from "lucide-react";

export default function DataTable({
    columns,
    rows,
    loading,
    onViewRow,
    onToggleHandled,
    supportsHandled,
    testIdPrefix,
    emptyLabel,
}) {
    const totalColumns =
        columns.length + (supportsHandled ? 1 : 0) + (onViewRow ? 1 : 0);

    return (
        <div
            className="border border-[rgba(201,168,106,0.2)] bg-[#15161A] overflow-hidden"
            data-testid={`${testIdPrefix}-table`}
        >
            <div className="overflow-x-auto">
                <table className="w-full border-collapse text-sm">
                    <thead className="sticky top-0 bg-[#1C1D22] z-10">
                        <tr className="border-b border-[rgba(201,168,106,0.2)]">
                            {columns.map((c) => (
                                <th
                                    key={c.key}
                                    className={`text-left px-5 py-4 text-[10px] tracking-[0.28em] uppercase text-[#9A958A] font-normal whitespace-nowrap ${
                                        c.className || ""
                                    }`}
                                >
                                    {c.label}
                                </th>
                            ))}
                            {supportsHandled && (
                                <th className="text-left px-5 py-4 text-[10px] tracking-[0.28em] uppercase text-[#9A958A] font-normal w-[90px]">
                                    Handled
                                </th>
                            )}
                            {onViewRow && (
                                <th className="text-right px-5 py-4 text-[10px] tracking-[0.28em] uppercase text-[#9A958A] font-normal w-[90px]">
                                    &nbsp;
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.length === 0 && !loading && (
                            <tr>
                                <td
                                    colSpan={totalColumns}
                                    className="px-5 py-12 text-center text-[#6e6a62] italic font-serif"
                                    data-testid={`${testIdPrefix}-empty`}
                                >
                                    {emptyLabel}
                                </td>
                            </tr>
                        )}
                        {loading && rows.length === 0 && (
                            <tr>
                                <td
                                    colSpan={totalColumns}
                                    className="px-5 py-12 text-center text-[#9A958A] text-[12px] tracking-[0.22em] uppercase"
                                >
                                    Loading…
                                </td>
                            </tr>
                        )}
                        {rows.map((r) => (
                            <tr
                                key={r.id}
                                className="border-b border-[rgba(201,168,106,0.08)] hover:bg-[#C9A86A]/[0.06] transition-colors duration-200 align-middle"
                                data-testid={`${testIdPrefix}-row-${r.id}`}
                            >
                                {columns.map((c) => (
                                    <td
                                        key={c.key}
                                        className={`px-5 py-4 text-[#F3EFE7] ${
                                            c.className || ""
                                        }`}
                                    >
                                        {c.render ? c.render(r) : r[c.key] ?? "—"}
                                    </td>
                                ))}
                                {supportsHandled && (
                                    <td className="px-5 py-4">
                                        <button
                                            type="button"
                                            role="switch"
                                            aria-checked={r.handled}
                                            onClick={() =>
                                                onToggleHandled && onToggleHandled(r)
                                            }
                                            className={`inline-flex items-center justify-center w-5 h-5 border transition-colors duration-200 ${
                                                r.handled
                                                    ? "bg-[#C9A86A] border-[#C9A86A] text-[#0B0B0C]"
                                                    : "border-[rgba(201,168,106,0.4)] hover:border-[#C9A86A]"
                                            }`}
                                            data-testid={`${testIdPrefix}-handled-${r.id}`}
                                            aria-label={
                                                r.handled
                                                    ? "Mark as unhandled"
                                                    : "Mark as handled"
                                            }
                                        >
                                            {r.handled && (
                                                <Check size={12} strokeWidth={2} />
                                            )}
                                        </button>
                                    </td>
                                )}
                                {onViewRow && (
                                    <td className="px-5 py-4 text-right">
                                        <button
                                            type="button"
                                            onClick={() => onViewRow(r)}
                                            className="text-[11px] tracking-[0.22em] uppercase text-[#C9A86A] hover:text-[#D9BC80] transition-colors duration-300"
                                            data-testid={`${testIdPrefix}-view-${r.id}`}
                                        >
                                            View →
                                        </button>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
